import React, { useEffect, useRef } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import FormInput from '../FormInput'
import { selectActiveBuilding } from '../../../../reducers/buildingSelectorReducer'
import { selectStatusIsLoadedAll, setLoadingState } from '../../../../reducers/clientsReducer'
import { visitorTypes, getVisitorTypeOptions, getPermissionTypes } from '../utils'
import SelectField from '../../../FormLegacy/FormFieldsV2/SelectField'

import CustomForm from './CustomForm'
import DailyForm from './DailyForm'
import WeeklyForm from './WeeklyForm'
import MonthlyForm from './MonthlyForm'

const SecondStep = ({
  selectedBuilding,
  values,
  setFieldValue,
  isVendorModal,
  isRecuringType: _isRecuringType,
  setLoadingState,
}) => {
  const { t } = useTranslation(['visitors'])
  const _lastSelectablePermissionRef = useRef(null)
  const permissionTypes = getPermissionTypes(t)

  useEffect(() => {
    if (values.pinCode || (!values.keyAccess && values.permissionType.id === 'one-time')) {
      setFieldValue('permissionType', { id: 'custom', text: t('visitors:permissions.oneTime') })
    }
  }, [values.keyAccess, values.pinCode, values.permissionType.id, setFieldValue, t])

  const renderInputBlocks = (values, setFieldValue) => {
    switch (values.permissionType.id) {
      case 'custom':
        return (
          <CustomForm
            values={values}
            setFieldValue={setFieldValue}
            selectedBuilding={selectedBuilding}
          />
        )
      case 'daily':
        return (
          <DailyForm
            values={values}
            setFieldValue={setFieldValue}
            selectedBuilding={selectedBuilding}
          />
        )

      case 'weekly':
        return (
          <WeeklyForm
            values={values}
            setFieldValue={setFieldValue}
            selectedDays={values.selectedDays}
          />
        )

      case 'monthly':
        return <MonthlyForm values={values} setFieldValue={setFieldValue} />
      default:
        return null
    }
  }

  return (
    <React.Fragment>
      {!isVendorModal && (
        <div className="columns">
          <div className="column is-12">
            <FormInput
              label={t('visitors:form.selectVisitorTypeLabel')}
              name="visitorType"
              isOptional
            >
              <SelectField
                name="visitorType"
                value={values.visitorType.id}
                placeholder={t('visitors:form.selectVisitorType')}
                options={getVisitorTypeOptions(t)}
                onChange={(e) => {
                  const selectedValue = visitorTypes.find((type) => type.id === e.target.value)
                  setFieldValue('visitorType', {
                    id: selectedValue.id,
                    text: selectedValue.text,
                  })
                }}
                onBlur={() => setLoadingState(false)}
                additionalClass="visitor-type-select"
              />
            </FormInput>
          </div>
        </div>
      )}
      <div className="columns">
        <div className="column is-12">
          <FormInput label={t('visitors:form.selectPermissionTypeLabel')} name="permissionType">
            <SelectField
              name="permissionType"
              value={values.permissionType.id}
              placeholder={t('visitors:form.selectPermissionType')}
              options={
                values.keyAccess || values.pinCode
                  ? [{ label: t('visitors:permissions.custom'), value: 'custom' }]
                  : permissionTypes.map((type) => ({ label: type.text, value: type.id }))
              }
              onChange={(e) => {
                const selectedValue = permissionTypes.find((type) => type.id === e.target.value)
                setFieldValue('permissionType', {
                  id: selectedValue.id,
                  text: selectedValue.text,
                })
              }}
              onBlur={() => setLoadingState(false)}
              additionalClass="permission-type-select"
              disabled={
                (values.keyAccess || values.pinCode) && values.permissionType.id === 'custom'
              }
            />
          </FormInput>
        </div>
      </div>
      <div className="columns">
        <div className="column is-12">{renderInputBlocks(values, setFieldValue)}</div>
      </div>
    </React.Fragment>
  )
}

SecondStep.propTypes = {
  selectedBuilding: PropTypes.object,
  values: PropTypes.object.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setLoadingState: PropTypes.func,
  isVendorModal: PropTypes.bool,
  isRecuringType: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    setLoadingState,
    selectedBuilding: selectActiveBuilding(state),
    allClientsLoaded: selectStatusIsLoadedAll(state),
  }
}

export default connect(mapStateToProps)(SecondStep)
